// DS: CR58
/** An image link in card form that displays art and title
 *  associated with a topic.
 */
import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '../../Context';
import { BiLink, BiEventType } from '../../biLogger';
import DeviationDumbo from '../../DeviationViews/Dumbo';
import s from './TopicCard.scss';
export var HOVERED_IMAGE_COUNT = 4;
var TopicCard = function (props) {
    var isMobile = useContext(MobileContext);
    var url = props.url, name = props.name, deviations = props.deviations, width = props.width, className = props.className, typeId = props.typeId, itemId = props.itemId, rank = props.rank;
    if (!url || !name || !width) {
        return null;
    }
    var images, coverDeviation;
    if (deviations === null || deviations === void 0 ? void 0 : deviations.length) {
        images = deviations.slice(1, HOVERED_IMAGE_COUNT);
        coverDeviation = deviations[0];
    }
    var classNames = classnames(s.root, className, !coverDeviation && s['missing-bg']);
    var linkStyles = { width: width, height: width };
    // floor was causing a single pixel gap on odd width, browser wanted a .5
    var halfWidth = Number((width / 2).toFixed(2));
    return (React.createElement(BiLink, { href: url, style: linkStyles, className: classNames, biData: {
            evid: BiEventType.ITEM_CLICK,
            typeid: typeId,
            itemid: itemId,
            rank: rank,
        } },
        coverDeviation && (React.createElement(DeviationDumbo, { className: classnames(s["cover"], s['deviation']), deviation: coverDeviation, key: coverDeviation.title, width: width, height: width })),
        !isMobile &&
            images &&
            images.map(function (deviation, i) { return (React.createElement(DeviationDumbo, { key: deviation.title, className: classnames(s["on-hover-" + i], s['deviation']), deviation: deviation, width: halfWidth, height: halfWidth })); }),
        React.createElement("div", { className: s['overlay'] }),
        React.createElement("h2", { className: s['name'] }, name)));
};
TopicCard.displayName = 'TopicCard';
export default TopicCard;
//# sourceMappingURL=TopicCard.js.map